import { initReactI18next } from 'react-i18next';
import 'dayjs/locale/ar';
import dayjs from 'dayjs';
import i18n from 'i18next';
import updateLocale from 'dayjs/plugin/updateLocale';
import LanguageDetector from 'i18next-browser-languagedetector';

import { translations } from '../src/locale/index';

dayjs.extend(updateLocale);

const symbolMap = {
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6',
  7: '7',
  8: '8',
  9: '9',
  0: '0',
};
const numberMap = {
  '١': '1',
  '٢': '2',
  '٣': '3',
  '٤': '4',
  '٥': '5',
  '٦': '6',
  '٧': '7',
  '٨': '8',
  '٩': '9',
  '٠': '0',
};
dayjs.updateLocale('ar', {
  preparse: function (string) {
    return string
      .replace(/\u200f/g, '')
      .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
        return numberMap[match];
      })
      .replace(/،/g, ',');
  },
  postformat: function (string) {
    return string
      .replace(/\d/g, function (match) {
        return symbolMap[match];
      })
      .replace(/,/g, '،');
  },
});

const resources = {
  en: {
    translation: translations.translationEN,
  },
  ar: {
    translation: translations.translationAR,
  },
};

const currentLanguage = localStorage.getItem('i18nextLng') || 'ar';
dayjs.locale(currentLanguage);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: currentLanguage,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
